import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useFetch } from 'shared/application/hooks'
import { b2bApi } from 'shared/infrastructure/clients'
import { inspectionLinkAdapter } from '../../adapter/inspectionLinkAdapter'

export const useInspectionLink = (idProposal = '') => {
  const [inspectionLinkCopied, setInspectionLinkCopied] = useState(false)
  const { id } = useParams()

  const { fetchData, response, error, loading } = useFetch(b2bApi, {
    method: 'GET',
    url: `/proposals/${idProposal || id}/inspection-link`,
  })
  const link = inspectionLinkAdapter(response)

  const copyLinkClipboard = text => {
    navigator.clipboard.writeText(text)
    setInspectionLinkCopied(true)
  }

  return {
    fetchData,
    link,
    error,
    loading,
    copyLinkClipboard,
    inspectionLinkCopied,
  }
}
